import { useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import donationsPlusDarkLogoSrc from './donations_plus_dark_logo.svg';
import donationsPlusLogoSrc from './donations_plus_logo.svg';
import msg from './messages';

interface DonationsPlusLogoProps {
  isDarkLogo?: boolean;
  width?: string;
}

const DonationsPlusLogo = ({ isDarkLogo = false, width }: DonationsPlusLogoProps) => {
  const { formatMessage } = useIntl();
  const { spacing } = useTheme();

  let imgStyle: { width?: string; padding?: string } = {
    width: width ?? spacing(17.5),
    padding: spacing(4, 0, 1, 0),
  };

  if (isDarkLogo) {
    imgStyle = width ? { width } : {};
  }

  return (
    <img
      style={imgStyle}
      src={isDarkLogo ? donationsPlusDarkLogoSrc : donationsPlusLogoSrc}
      alt={formatMessage({ ...msg.logoAltText })}
    />
  );
};

export default DonationsPlusLogo;
